// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AccountSettings_wrapper__g95Bw"};